// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-nav {
    /* color palette variables (inlined here for navbar) */
}

:root {
    --color-primary: #374151;
    --color-secondary: #aa613a;
    --color-accent: #E8B4A0;
    --color-neutral: #FFFEF7;
    --color-text: #231F20;
}

.floating-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 5000;
    padding: 16px 25px;
    width: 100%;
    background: transparent;
    pointer-events: none;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* When the edge-features section is visible hide the floating nav */
body.edge-nav-hidden .floating-nav {
    transform: translateY(-120%);
    opacity: 0;
    pointer-events: none;
}

.floating-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    pointer-events: auto;
    max-width: 1600px;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.76);
    border-radius: 20px;
    padding: 12px 16px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 
                0 1px 3px rgba(0, 0, 0, 0.08),
                inset 0 1px 0 rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
}

.floating-inner::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    opacity: 0.6;
    pointer-events: none;
}

.floating-logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 4px 12px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
}

.floating-logo:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
}

.floating-left {
    display: flex;
    gap: 6px;
    border-radius: 14px;
    padding: 6px 8px;
    align-items: center;
    justify-content: center;
}

/* Navigation items */
.nav-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    text-decoration: none;
    color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.95rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.nav-item::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        rgba(170, 97, 58, 0.2) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.nav-item:hover {
    color: #ffffff;
    transform: translateY(-1px);
}

.nav-item:hover::before {
    opacity: 1;
}

.nav-item.active::before {
    opacity: 1;
}

.nav-item.active::after {
    width: 80%;
    height: 3px;
    background: linear-gradient(90deg, 
        transparent 0%,
        var(--color-accent) 20%,
        var(--color-neutral) 50%,
        var(--color-accent) 80%,
        transparent 100%);
    box-shadow: 0 0 8px rgba(232, 180, 160, 0.6);
}

.nav-item::after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 2px;
    background: var(--color-neutral);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 2px;
}

.nav-item:hover::after {
    width: 80%;
}

.nav-icon {
    display: inline-flex;
    font-size: 1.1rem;
    color: inherit;
}

.nav-label {
    display: inline;
    white-space: nowrap;
    color: inherit;
}

.nav-logo {
    width: 48px;
    height: 48px;
    object-fit: contain;
    border-radius: 8px;
    /* if logo is dark, you can optionally add a subtle backdrop for contrast:
         background: rgba(255,255,255,0.04); padding: 4px; */
}

.floating-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

/* transparent primary action with white border */
.nav-login {
    padding: 10px 20px;
    border-radius: 10px;
    border: none;
    background: var(--color-secondary);
    color: #ffffff;
    cursor: pointer;
    font-weight: 700;
    font-size: 0.95rem;
    transition: all 0.28s ease;
    box-shadow: 0 6px 18px rgba(200, 121, 65, 0.12);
}

.nav-login:hover {
    transform: translateY(-2px);
    filter: brightness(0.98);
}


@media (max-width: 1024px) {
    .floating-nav {
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        margin: 0;
        padding: 20px 10px;
        width: 100%;
        max-width: 100%;
        background: transparent !important;
        pointer-events: auto;
    }

    .floating-inner {
        gap: 8px;
    }

    .floating-logo {
        display: flex;
        background: transparent !important;
        align-items: center;
        flex-shrink: 0;
        border-radius: 16px;
        padding: 6px 20px;
        border: none;
    }

    .brand-logo {
        /* width: 44px; */
        height: 22px !important;
    }

    /* Hide desktop nav on mobile */
    .floating-left-desktop {
        display: none;
    }

    /* Show hamburger button on mobile */
    .mobile-menu-button {
        display: flex !important;
        top: 20px;
        right: 20px !important;
    }

    .nav-icon {
        font-size: 1rem;
    }

    .nav-logo {
        width: 36px;
        height: 36px;
    }

    .nav-login {
        padding: 8px 14px;
        font-size: 0.85rem;
    }
}


.brand {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
    font-weight: 800;
    margin: 0;
    letter-spacing: -0.02em;
    text-decoration: none;
    color: #ffffff;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;
}

.brand-logo {
    height: 34px;
    object-fit: contain;
    border-radius: 8px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    transition: all 0.3s ease;
}

.brand-text {
    color: #ffffff;
    font-weight: 800;
    text-transform: none;
    font-size: 1rem;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.brand:hover .brand-logo {
    filter: drop-shadow(0 4px 8px rgba(232, 180, 160, 0.4));
    transform: scale(1.05);
}

/* Mobile hamburger button - hidden on desktop */
.mobile-menu-button {
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    cursor: pointer;
    padding: 10px;
    z-index: 10;
    transition: all 0.3s ease;
}

.mobile-menu-button:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.2);
    transform: scale(1.05);
}

.hamburger-line {
    width: 100%;
    height: 2.5px;
    background: white;
    border-radius: 2px;
    transition: all 0.3s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Mobile menu overlay */
.mobile-menu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 4999;
}

/* Mobile menu drawer */
.mobile-menu-drawer {
    position: fixed;
    top: 20px;
    right: 20px;
    height: fit-content;
    width: 320px;
    max-width: 85vw;
    background: rgba(255, 254, 247, 0.95);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    z-index: 5001;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2),
                0 8px 24px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(170, 97, 58, 0.1);
    overflow: hidden;
    color: var(--color-text);
}

.mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-bottom: 1px solid rgba(170, 97, 58, 0.1);
    background: linear-gradient(135deg, 
        rgba(170, 97, 58, 0.03) 0%, 
        rgba(232, 180, 160, 0.05) 100%);
}

.mobile-menu-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-text);
    margin: 0;
    background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-accent) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.mobile-menu-close {
    background: rgba(170, 97, 58, 0.08);
    border: 1px solid rgba(170, 97, 58, 0.15);
    color: var(--color-secondary);
    font-size: 1.25rem;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    transition: all 0.2s ease;
}

.mobile-menu-close:hover {
    background: rgba(170, 97, 58, 0.15);
    transform: rotate(90deg) scale(1.05);
}

.mobile-menu-nav {
    display: flex;
    flex-direction: column;
    padding: 12px 0;
}

.mobile-nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    text-decoration: none;
    color: var(--color-text);
    font-size: 1.05rem;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-left: 3px solid transparent;
    position: relative;
    overflow: hidden;
}

.mobile-nav-item::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, 
        rgba(170, 97, 58, 0.08) 0%, 
        rgba(232, 180, 160, 0.04) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.mobile-nav-item:hover {
    color: var(--color-secondary);
    border-left-color: var(--color-secondary);
}

.mobile-nav-item:hover::before {
    opacity: 1;
}

/* Mobile active state */
.mobile-nav-item.active {
    color: var(--color-secondary);
    border-left-color: var(--color-secondary);
    font-weight: 700;
}

.mobile-nav-item.active::before {
    opacity: 1;
}

.mobile-nav-item.active::after {
    content: '';
    position: absolute;
    right: 24px;
    width: 6px;
    height: 6px;
    background: var(--color-secondary);
    border-radius: 50%;
    box-shadow: 0 0 8px rgba(170, 97, 58, 0.5);
}

.mobile-nav-icon {
    font-size: 1.25rem;
    width: 24px;
    text-align: center;
}

.mobile-nav-label {
    flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/styles/floating-navbar.css"],"names":[],"mappings":"AAAA;IACI,sDAAsD;AAC1D;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA,oEAAoE;AACpE;IACI,4BAA4B;IAC5B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C;;sDAEkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,8EAA8E;IAE9E,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;oCAEgC;IAChC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX;;;;;yBAKqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB;4DACwD;AAC5D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA,iDAAiD;AACjD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;;AAGA;IACI;QACI,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,QAAQ;QACR,SAAS;QACT,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,kCAAkC;QAClC,oBAAoB;IACxB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,kCAAkC;QAClC,mBAAmB;QACnB,cAAc;QACd,mBAAmB;QACnB,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA,+BAA+B;IAC/B;QACI,aAAa;IACjB;;IAEA,oCAAoC;IACpC;QACI,wBAAwB;QACxB,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;;AAGA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,uDAAuD;IACvD,sBAAsB;AAC1B;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;IAC3B,2CAA2C;IAC3C,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,0CAA0C;IAC1C,kDAAkD;IAClD,aAAa;IACb;6CACyC;IACzC,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,+CAA+C;IAC/C;;uCAEmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,SAAS;IACT,wFAAwF;IACxF,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,iDAAiD;IACjD,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;uCAEmC;IACnC,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,UAAU;AACd;;AAEA,wBAAwB;AACxB;IACI,6BAA6B;IAC7B,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAO;AACX","sourcesContent":[".floating-nav {\n    /* color palette variables (inlined here for navbar) */\n}\n\n:root {\n    --color-primary: #374151;\n    --color-secondary: #aa613a;\n    --color-accent: #E8B4A0;\n    --color-neutral: #FFFEF7;\n    --color-text: #231F20;\n}\n\n.floating-nav {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    z-index: 5000;\n    padding: 16px 25px;\n    width: 100%;\n    background: transparent;\n    pointer-events: none;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* When the edge-features section is visible hide the floating nav */\nbody.edge-nav-hidden .floating-nav {\n    transform: translateY(-120%);\n    opacity: 0;\n    pointer-events: none;\n}\n\n.floating-inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    pointer-events: auto;\n    max-width: 1600px;\n    margin: 0 auto;\n    background: rgba(0, 0, 0, 0.76);\n    border-radius: 20px;\n    padding: 12px 16px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), \n                0 1px 3px rgba(0, 0, 0, 0.08),\n                inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    position: relative;\n    overflow: hidden;\n}\n\n.floating-inner::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 20px;\n    padding: 1px;\n    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n.floating-logo {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    padding: 4px 12px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    transition: all 0.3s ease;\n}\n\n.floating-logo:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.2);\n    transform: translateY(-1px);\n}\n\n.floating-left {\n    display: flex;\n    gap: 6px;\n    border-radius: 14px;\n    padding: 6px 8px;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Navigation items */\n.nav-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px 20px;\n    text-decoration: none;\n    color: rgba(255, 255, 255, 0.9);\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 0.95rem;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.nav-item::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, \n        rgba(255, 255, 255, 0.15) 0%, \n        rgba(170, 97, 58, 0.2) 100%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.nav-item:hover {\n    color: #ffffff;\n    transform: translateY(-1px);\n}\n\n.nav-item:hover::before {\n    opacity: 1;\n}\n\n.nav-item.active::before {\n    opacity: 1;\n}\n\n.nav-item.active::after {\n    width: 80%;\n    height: 3px;\n    background: linear-gradient(90deg, \n        transparent 0%,\n        var(--color-accent) 20%,\n        var(--color-neutral) 50%,\n        var(--color-accent) 80%,\n        transparent 100%);\n    box-shadow: 0 0 8px rgba(232, 180, 160, 0.6);\n}\n\n.nav-item::after {\n    content: '';\n    position: absolute;\n    bottom: 4px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 2px;\n    background: var(--color-neutral);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-radius: 2px;\n}\n\n.nav-item:hover::after {\n    width: 80%;\n}\n\n.nav-icon {\n    display: inline-flex;\n    font-size: 1.1rem;\n    color: inherit;\n}\n\n.nav-label {\n    display: inline;\n    white-space: nowrap;\n    color: inherit;\n}\n\n.nav-logo {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n    border-radius: 8px;\n    /* if logo is dark, you can optionally add a subtle backdrop for contrast:\n         background: rgba(255,255,255,0.04); padding: 4px; */\n}\n\n.floating-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-shrink: 0;\n}\n\n/* transparent primary action with white border */\n.nav-login {\n    padding: 10px 20px;\n    border-radius: 10px;\n    border: none;\n    background: var(--color-secondary);\n    color: #ffffff;\n    cursor: pointer;\n    font-weight: 700;\n    font-size: 0.95rem;\n    transition: all 0.28s ease;\n    box-shadow: 0 6px 18px rgba(200, 121, 65, 0.12);\n}\n\n.nav-login:hover {\n    transform: translateY(-2px);\n    filter: brightness(0.98);\n}\n\n\n@media (max-width: 1024px) {\n    .floating-nav {\n        position: absolute;\n        top: 0px;\n        left: 0;\n        right: 0;\n        margin: 0;\n        padding: 20px 10px;\n        width: 100%;\n        max-width: 100%;\n        background: transparent !important;\n        pointer-events: auto;\n    }\n\n    .floating-inner {\n        gap: 8px;\n    }\n\n    .floating-logo {\n        display: flex;\n        background: transparent !important;\n        align-items: center;\n        flex-shrink: 0;\n        border-radius: 16px;\n        padding: 6px 20px;\n        border: none;\n    }\n\n    .brand-logo {\n        /* width: 44px; */\n        height: 22px !important;\n    }\n\n    /* Hide desktop nav on mobile */\n    .floating-left-desktop {\n        display: none;\n    }\n\n    /* Show hamburger button on mobile */\n    .mobile-menu-button {\n        display: flex !important;\n        top: 20px;\n        right: 20px !important;\n    }\n\n    .nav-icon {\n        font-size: 1rem;\n    }\n\n    .nav-logo {\n        width: 36px;\n        height: 36px;\n    }\n\n    .nav-login {\n        padding: 8px 14px;\n        font-size: 0.85rem;\n    }\n}\n\n\n.brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 1.1rem;\n    font-weight: 800;\n    margin: 0;\n    letter-spacing: -0.02em;\n    text-decoration: none;\n    color: #ffffff;\n    position: relative;\n    z-index: 1;\n    transition: all 0.3s ease;\n}\n\n.brand-logo {\n    height: 34px;\n    object-fit: contain;\n    border-radius: 8px;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n    transition: all 0.3s ease;\n}\n\n.brand-text {\n    color: #ffffff;\n    font-weight: 800;\n    text-transform: none;\n    font-size: 1rem;\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.brand:hover .brand-logo {\n    filter: drop-shadow(0 4px 8px rgba(232, 180, 160, 0.4));\n    transform: scale(1.05);\n}\n\n/* Mobile hamburger button - hidden on desktop */\n.mobile-menu-button {\n    display: none;\n    flex-direction: column;\n    justify-content: space-around;\n    width: 44px;\n    height: 44px;\n    background: rgba(255, 255, 255, 0.08);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 12px;\n    cursor: pointer;\n    padding: 10px;\n    z-index: 10;\n    transition: all 0.3s ease;\n}\n\n.mobile-menu-button:hover {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: rgba(255, 255, 255, 0.2);\n    transform: scale(1.05);\n}\n\n.hamburger-line {\n    width: 100%;\n    height: 2.5px;\n    background: white;\n    border-radius: 2px;\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n/* Mobile menu overlay */\n.mobile-menu-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 4999;\n}\n\n/* Mobile menu drawer */\n.mobile-menu-drawer {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    height: fit-content;\n    width: 320px;\n    max-width: 85vw;\n    background: rgba(255, 254, 247, 0.95);\n    backdrop-filter: blur(20px) saturate(180%);\n    -webkit-backdrop-filter: blur(20px) saturate(180%);\n    z-index: 5001;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2),\n                0 8px 24px rgba(0, 0, 0, 0.1);\n    border-radius: 20px;\n    border: 1px solid rgba(170, 97, 58, 0.1);\n    overflow: hidden;\n    color: var(--color-text);\n}\n\n.mobile-menu-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px;\n    border-bottom: 1px solid rgba(170, 97, 58, 0.1);\n    background: linear-gradient(135deg, \n        rgba(170, 97, 58, 0.03) 0%, \n        rgba(232, 180, 160, 0.05) 100%);\n}\n\n.mobile-menu-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: var(--color-text);\n    margin: 0;\n    background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-accent) 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.mobile-menu-close {\n    background: rgba(170, 97, 58, 0.08);\n    border: 1px solid rgba(170, 97, 58, 0.15);\n    color: var(--color-secondary);\n    font-size: 1.25rem;\n    cursor: pointer;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    transition: all 0.2s ease;\n}\n\n.mobile-menu-close:hover {\n    background: rgba(170, 97, 58, 0.15);\n    transform: rotate(90deg) scale(1.05);\n}\n\n.mobile-menu-nav {\n    display: flex;\n    flex-direction: column;\n    padding: 12px 0;\n}\n\n.mobile-nav-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 24px;\n    text-decoration: none;\n    color: var(--color-text);\n    font-size: 1.05rem;\n    font-weight: 600;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-left: 3px solid transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.mobile-nav-item::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(90deg, \n        rgba(170, 97, 58, 0.08) 0%, \n        rgba(232, 180, 160, 0.04) 100%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.mobile-nav-item:hover {\n    color: var(--color-secondary);\n    border-left-color: var(--color-secondary);\n}\n\n.mobile-nav-item:hover::before {\n    opacity: 1;\n}\n\n/* Mobile active state */\n.mobile-nav-item.active {\n    color: var(--color-secondary);\n    border-left-color: var(--color-secondary);\n    font-weight: 700;\n}\n\n.mobile-nav-item.active::before {\n    opacity: 1;\n}\n\n.mobile-nav-item.active::after {\n    content: '';\n    position: absolute;\n    right: 24px;\n    width: 6px;\n    height: 6px;\n    background: var(--color-secondary);\n    border-radius: 50%;\n    box-shadow: 0 0 8px rgba(170, 97, 58, 0.5);\n}\n\n.mobile-nav-icon {\n    font-size: 1.25rem;\n    width: 24px;\n    text-align: center;\n}\n\n.mobile-nav-label {\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
